import React from 'react'

function whatsapp() {

    const redirectToWhatsApp = (product) => {
        // const phoneNumber = "+918092144414"; // Your WhatsApp number here
        const phoneNumber = "+919347566010"; // Your WhatsApp number here
        const id = product.id;
        const productName = product.name;
        const productPrice = product.price;
        const productImage = product.image; // Image URL

        const message = `Hello, I am interested in purchasing the following product:
        ID: ${id}
        Product Name: ${productName}
        Price: RS ${productPrice}
        
        You can view the product image here: ${productImage}`;

        const encodedMessage = encodeURIComponent(message);
        const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodedMessage}`;

        // Open the WhatsApp chat link in a new tab
        window.open(whatsappUrl, '_blank');
    };


    return { redirectToWhatsApp }

}

export default whatsapp